import { type ReactNode, useRef } from 'react'
import type { StoreApi } from 'zustand'

import { type AnalysisStore, createAnalysisStore } from '@/modules/analysis'
import { type ChatStore, createChatStore } from '@/modules/chat'
import {
  createInsightsStore,
  createProjectStore,
  type InsightsStore,
  type ProjectStore,
} from '../stores'
import { ProjectContext } from './ProjectStoreContext'

interface ProjectProviderProps {
  children: ReactNode
}

export const ProjectProvider = ({ children }: ProjectProviderProps) => {
  const projectStoreRef = useRef<StoreApi<ProjectStore>>(createProjectStore())
  const analysisStoreRef = useRef<StoreApi<AnalysisStore>>(
    createAnalysisStore(),
  )
  const insightsStoreRef = useRef<StoreApi<InsightsStore>>(
    createInsightsStore(),
  )
  const chatStoreRef = useRef<StoreApi<ChatStore>>(createChatStore())
  return (
    <ProjectContext.Provider
      value={{
        projectStore: projectStoreRef.current,
        projectAnalysisStore: analysisStoreRef.current,
        insightsStore: insightsStoreRef.current,
        chatStore: chatStoreRef.current,
      }}
    >
      {children}
    </ProjectContext.Provider>
  )
}
